/* unplugin-vue-components disabled */import script from "./sign.vue?vue&type=script&setup=true&lang=ts"
export * from "./sign.vue?vue&type=script&setup=true&lang=ts"

import "./sign.vue?vue&type=style&index=0&id=95b94290&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95b94290"]])

export default __exports__